import fetch from "@/uilts/request";


// 深圳风控报告
export default {
    /**
     * 创建授权书
     */
    async createAuthorization(data) {
        return await fetch.post("ZwZci127/createAuthorization", data)
    },


    /**
     * 获取风控结果
     */

    async zci127Submit(data){
        return await fetch.post("ZwZci127/zci127Submit", data)
    },


    


}




